import React, { Component } from "react";
import Layout from "../../components/Layout";
import Meta from "../../components/Meta";
import MenuEN from "../../components/en/MenuEN";
import FooterEN from "../../components/en/FooterEN";

class Index extends Component {
    constructor(props) {
        super(props);
    }

    render() {
        return (
            <Layout>
                <Meta
                    title={"What solutions for a company in difficulty?"}
                    description={"Cash flow problems? Profitability? Debts to the tax authorities, VAT or NSSO? JRP and bankruptcy are not inevitable. Here's how to react."}
                    url={"https://www.coeladvocaten.be/en/companies-in-difficulty"}
                    robots={"index, follow"}
                    languages={[
                        { url:"https://www.coeladvocaten.be/nl/bedrijven-in-moeilijkheden", language:"nl" },
                        { url:"https://www.coeladvocaten.be/fr/entreprises-en-difficultes", language:"fr" },
                        { url:"https://www.coeladvocaten.be/en/companies-in-difficulty", language:"en" }
                    ]}
                />

                <MenuEN
                    switchUrlNL="/nl/bedrijven-in-moeilijkheden"
                    switchUrlFR="/fr/entreprises-en-difficultes"
                />

                <div className="page">
                    <div className="header">
                        <div className="grayscale background background-entreprises-en-difficultes"></div>
                        <div className="slider">
                            <h1>Our services</h1>
                            <h2>Is your company in difficulty? We can help you!</h2>
                            <p></p>
                            <a href="/en/contact" alt="contact" className="button">info@coeladvocaten.be</a>
                        </div>
                    </div>

                    <div className="content">
                        <div className="container press">
                            <div className="row">
                                <div className="col-lg-4">
                                    <div className="slider">
                                        <div className="margin-top">                                            
                                            <p><div className="timeline"><a href="#step1">1. Evaluate the situation</a></div></p>
                                            <p><div className="timeline"><a href="#step2">2. Establish a list of actions and define priorities</a></div></p>
                                            <p><div className="timeline"><a href="#step3">3. Implement your recovery plan</a></div></p>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-lg-8">
                                    <div className="slider">
                                        <div className="margin-top">
                                            <p>Cash flow problems? Profitability at a low ebb? Debts to the tax authorities, VAT or the NSSO? JRP and bankruptcy are not inevitable, provided you react. Here's how.</p>
                                            <p>Is your business experiencing difficulties? Don't give up: our experience has proven to us that there is often a solution. We offer you tailor-made support to help you evaluate the situation, decide on the measures to be taken and implement them.</p>
                                            <p><b>Restructuring your business in three steps</b></p>
                                            <p id="step1"></p>
                                            <p><i>1. Evaluate the situation</i></p>
                                            <p>First step: gather all the elements necessary to evaluate the situation. Depending on your situation, this means:</p>
                                            <p>- Analyzing the evolution of your accounts to <b>identify the origin of your situation</b> (if necessary, establishing your latest annual accounts beforehand)</p>
                                            <p>- Studying the <b>profitability of the different activities</b> with the idea of deciding which ones to pursue and identifying cost reduction opportunities</p>
                                            <p>- Drawing up the <b>list of the company's creditors</b> to evaluate the degree of debt and the urgent or non-urgent nature of the repayments</p>
                                            <p>- Drawing up the <b>list of the company's debtors</b>, with the aim of estimating the possibilities of financing part of the repayments</p>
                                            <p>- Creating a <b>cash flow plan</b> to identify upcoming deadlines and the means necessary to meet them</p>
                                            <p id="step2"></p>
                                            <p>&nbsp;</p>
                                            <p><i>2. Establish a list of actions and define priorities</i></p>
                                            <p>As soon as we have finished analyzing your company's situation, it becomes possible to discuss together the <b>decisions</b> that are necessary to <b>resolve the situation</b>.</p>
                                            <p>To start, you should decide between three possible options:</p>
                                            <p>- The <b>reorganization</b> with continued activity</p>
                                            <p>- Starting a <b>JRP — a judicial reorganization procedure</b>. The JRP allows you to obtain temporary respite from creditors and to have the necessary perspective to evaluate the possibility of restoring the company.</p>
                                            <p>- Filing for <b>bankruptcy</b>. If it is not possible to return the company to a situation where it records profits and repays its debts, it is better to act as quickly as possible to protect yourself as much as possible from the consequences of a bankruptcy on your own assets. </p>
                                            <p>If it is possible to <b>recover your business</b>, a plan of the different actions to be implemented should be determined. Depending on your situation, this will involve among other things: </p>
                                            <p>- Deciding <b>which activities to pursue</b> and which activities to stop</p>
                                            <p>- Implementing a cost reduction plan</p>
                                            <p>- Deciding on the advisability of implementing the <b>recovery of unpaid debts</b> from your debtors</p>
                                            <p>- Deciding on possible <b>dismissals</b></p>
                                            <p>- Developing several repayment scenarios for each creditor to prepare for <b>negotiations</b></p>
                                            <p id="step3"></p>
                                            <p>&nbsp;</p>
                                            <p><i>3. Implement your recovery plan</i></p>
                                            <p>The last step consists of implementing the different measures you have planned. We also support you at this crucial stage. Our lawyers are indeed ideally placed to: </p>
                                            <p>- <b>Negotiate</b> with the different parties to reach a <b>balanced agreement</b></p>
                                            <p>- <b>Identify</b> possibilities for obtaining <b>restructuring aid</b></p>
                                            <p>- Call on, if necessary, a network of <b>trusted professionals</b>: notaries, real estate experts, accountants, company auditors, bailiffs. </p>
                                            <p>&nbsp;</p>
                                            <p><b>Is your company in difficulty?</b></p>
                                            <p>Do not hesitate to contact us. We will carry out an initial evaluation of your situation during a preliminary interview. </p>
                                            <p><br /></p>
                                            <p className="text-center"><a href="/en/contact" alt="contact" className="button">info@coeladvocaten.be</a></p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="row"><br /></div>
                        </div>
                    </div>
                </div>

                <FooterEN />
            </Layout>
        );
    }
}

export default Index;
